import React from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../../services/supabaseClient';

// Hook para verificar se o admin está autenticado
function useAdminAuth() {
  const [loading, setLoading] = React.useState(true);
  const [session, setSession] = React.useState(null);

  React.useEffect(() => {
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });
    return () => {
      listener?.subscription.unsubscribe();
    };
  }, []);

  return { loading, session };
}

const AdminRoute = ({ children }) => {
  const { loading, session } = useAdminAuth();

  if (loading) return null;
  if (!session) return <Navigate to="/admin/login" replace />;
  return children;
};

export default AdminRoute;
